import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=6ed45605&scoped=true&"
import script from "./ContactDetail.vue?vue&type=script&lang=ts&"
export * from "./ContactDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ContactDetail.vue?vue&type=style&index=0&id=6ed45605&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed45605",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VChip,VCol,VDivider,VFlex,VLayout,VRow,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed45605')) {
      api.createRecord('6ed45605', component.options)
    } else {
      api.reload('6ed45605', component.options)
    }
    module.hot.accept("./ContactDetail.vue?vue&type=template&id=6ed45605&scoped=true&", function () {
      api.rerender('6ed45605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/contacts/directory/components/ContactDetail.vue"
export default component.exports